export default __webpack_public_path__ + "static/bounty@2x-7f6dee517e2af9874e81a89cd2dca2e1.png";